<template>
  <section>
<!--    <h3 class="h3Title">SMS 발송</h3>-->
    <div class="fieldWrap mgb3">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt class="formTit">기간 검색</dt>
            <dd>
              <date-range-component v-on:event="getSearchDate" label="발송일" :value="param.searchDate" style="width: 250px"></date-range-component>
            </dd>
            <dd>
              <div class="monthBx">
                <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                        :class="{ active: month === activeItem}"
                        @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                </button>
              </div>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">전송결과</dt>
            <dd class="checkSt">
              <v-radio-group class="formInRadio " v-model="param.searchStatusCode" :mandatory="true" row>
                <v-radio label="전체" value=""/>
                <v-radio label="성공" value="true"/>
                <v-radio label="실패" value="false"/>
              </v-radio-group>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">전송타입</dt>
            <dd class="checkSt">
              <v-radio-group class="formInRadio " v-model="param.searchSendType" :mandatory="true" row>
                <v-radio label="전체" value=""/>
                <v-radio label="즉시 발송" value="SMS"/>
                <v-radio label="예약 발송" value="SMS_RESERVATION"/>
<!--                <v-radio label="예약 발송 대기" value="SMS_RESERVATION_WAIT"/>-->
                <!-- <v-radio label="PUSH 발송" :value="PUSH"/>
                <v-radio label="MULTI 발송" :value="PUSH_SMS"/> -->
              </v-radio-group>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">제목 / 내용</dt>
            <dd class="checkSt">
              <v-col class="d-flex">
                <v-text-field label="검색어를 입력해주세요."
                              v-model="param.searchKeyword" v-on:keyup.enter="getSmsHistoryList"
                              dense clearable flat outlined
                              style="padding-right: 10px; width:400px"
                />

                <v-btn color="#424964" @click="getSmsHistoryList()" depressed dark>검색</v-btn>
              </v-col>
            </dd>
          </dl>
        </li>
<!--        <li class="formList">-->
<!--          <dl>-->
<!--            <dt class="formTit">전송주체</dt>-->
<!--            <dd class="checkSt">-->
<!--              <v-radio-group class="formInRadio " v-model="param.sendUser" :mandatory="true" row>-->
<!--                <v-radio label="전체" value=""/>-->
<!--                <v-radio label="사용자" value="SMS"/>-->
<!--                <v-radio label="시스템" value="SMS_RESERVATION"/>-->
<!--              </v-radio-group>-->
<!--            </dd>-->
<!--          </dl>-->
<!--        </li>-->
<!--        <li class="searchBtn">-->
<!--          <v-btn color="#424964" @click="getSmsHistoryList()" depressed dark>검색</v-btn>-->
<!--        </li>-->
      </ul>
    </div>
    <div class="tableWrap">
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="smsHistoryList"
          :single-select="singleSelect"
          :server-items-length="totalItems"
          :options.sync="dataTableOptions"
          :loading="listLoading"
          item-key="requestId"
          class="elevation-1"
          :footer-props="{showFirstLastPage: true}"
          disable-sort
          :single-expand="true"
          :expanded.sync="expanded"
          @item-expanded="expandHistory"
          show-expand
      >
        <template v-slot:item.result="{ item }">
          성공: {{ item.successCount }}
          실패: {{ item.failCount }}
        </template>
        <template v-slot:item.requestTime="{ item }">
          {{ item.requestTime | moment('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template v-slot:item.totalCount="{ item }">
            {{ item.totalCount }} 건
        </template>

        <template v-slot:item.sendType="{ value }">
          {{ value === 'SMS' ? '즉시발송' : value === 'SMS_RESERVATION' ? '예약발송' : value }}
        </template>

        <template v-slot:expanded-item="{ headers }">
          <td :colspan="headers.length" style="padding: 20px 20px 20px 20px">

            <v-card>
              <v-card-title>
                전송 상세
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="searchMessage"
                    append-icon="mdi-magnify"
                    label="전송 상세 검색"
                    single-line
                    hide-details
                ></v-text-field>
              </v-card-title>

              <v-data-table
                  :headers="messageHeaders"
                  :items="messages"
                  :footer-props="{showFirstLastPage: true}"
                  :search="searchMessage"
                  class="elevation-1"
              >
<!--                <template v-slot:top>-->
<!--                  <v-toolbar flat>-->
<!--                    <v-toolbar-title>-</v-toolbar-title>-->
<!--                    <v-divider-->
<!--                        class="mx-4"-->
<!--                        inset-->
<!--                        vertical-->
<!--                    ></v-divider>-->
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-btn class="mb-2" v-on:click="createItemForm(item)">-->
<!--                      상세 검색-->
<!--                    </v-btn>-->
<!--                  </v-toolbar>-->
<!--                </template>-->
                <template v-slot:item.messageContent="{item}">
                  {{ item.messageContent ? item.messageContent : item.content }}
                </template>
              </v-data-table>

            </v-card>
          </td>
        </template>
      </v-data-table>
    </div>
  </section>
</template>

<script>
import SmsApi from '@/api/SmsApi';
import DateRageComponent from "@/views/component/DateRageComponent";

export default {
  name: "SmsHistory",
  components: {'date-range-component': DateRageComponent},
  props: {
    groupId: String,
    present: {
      type: Boolean,
      default: false
    },
    recipientId: String
  },
  data: () => ({
    SmsDialog: false,
    totalItems: 0,
    menu: false,
    menu2: false,
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    param: {
      fromDate: new Date().toISOString().substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      isSuccess: null,
      sendType: null,
    },
    singleSelect: false,
    selected: [],
    headers: [
      {text: '번호', value: 'idx', align: 'center'},
      {text: '발송 요청 일자', value: 'requestTime', align: 'center'},
      {text: '발송 건수', value: 'totalCount', align: 'center'},
      {text: '전송 결과', value: 'result', align: 'center'},
      {text: '전송 타입', value: 'sendType', align: 'center'},
      {text: '전송자', value: 'senderId', align: 'center'},
      {text: '문자 제목', value: 'subject', align: 'center'},
      {text: '문자 내용', value: 'content', align: 'center'},
      {text: '상세', value: 'data-table-expand', align: 'center'},
    ],
    dataTableOptions: {
      page: 1,
      itemsPerPage: 10
    },
    smsHistoryList: [],
    messageHeaders: [
      {text: '발송 일자', value: 'messageCompleteTime', align: 'center'},
      {text: '발송 처리 상태', value: 'messageStatus', align: 'center'},
      {text: '수신 번호', value: 'toNo', align: 'center'},
      {text: '수신자', value: 'recipientId', align: 'center'},
      {text: '문자 내용', value: 'messageContent', align: 'center'}
    ],
    messages:[],
    listLoading: true,
    activeItem: null,
    expanded: [],
    searchMessage:null
  }),
  methods: {
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectItem(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    async getSmsHistoryList() {

      const {page, itemsPerPage, size} = this.dataTableOptions;

      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      // params.size = params.itemsPerPage;
      // params.page = (page - 1);
      // params.size = itemsPerPage;

      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      params.groupId = this.groupId;
      params.present = this.present;
      params.recipientId = this.recipientId;

      SmsApi.getSmsHistoryList(params).then(data => {
        this.listLoading = false;
        this.smsHistoryList = data.content.map((a, i) => {
          a.idx = data.totalElements - i - (( (params.page??1) - 1) * params.size);
          return a;
        });
        this.totalItems = data.totalElements;
      });
    },
    expandHistory({item, value}) {
      // console.log(item)
      // console.log(value)
      if(value) {
        SmsApi.getSmsMessages(item.requestId).then(data => {
          this.messages = data;
        });
      } else {
        this.messages = [];
      }

    }
  },
  watch: {
    dataTableOptions: {
      handler() {
        this.getSmsHistoryList()
      },
      deep: true,
    },
  },
  created: function () {
    this.selectItem(1, 0);
    // this.getSmsHistoryList();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h3Title {
  @include h3-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          .monthBx {
            display: flex;
            align-items: center;
            width: 280px;
            height: 34px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }

      .searchBtn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 1.7%;
      }
    }
  }
}
</style>
